import get from 'lodash/get';
import * as micYearDescriptionActions from '../../action_creators/mic/mic_year_description_action_creators';
import MicYearDescriptionModel from '../../../models/mic/mic_year_description_model';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import log from '../../../services/logger_service';

export default function fetchMicDescription(params, store) {
  return function firstDispatch(dispatch) {
    return MicYearDescriptionModel.fetch(params, store)
      .then(function handleMicDetailData(MicData) {
        dispatch(
          micYearDescriptionActions.micYearDescriptionLoaded(
            {
              rows: MicData.data
            },
            store
          )
        );
      })
      .catch(function handleUserError(err) {
        if (err.message === 'Invalid Year') {
          log.warn('User tried a most creative people page with invalid year.');
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
          return dispatch(
            micYearDescriptionActions.micYearDescriptionLoadError(err, store)
          );
        }

        const status = get(err, 'response.status');

        if (status === 404 || status === 401) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        }

        if (status === 500) {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(
            err,
            `Error in micYearDescription actions, message: ${err.message}`
          );
        }

        return dispatch(
          micYearDescriptionActions.micYearDescriptionLoadError(err, store)
        );
      });
  };
}
